import Vue from "vue";
import VueRouter from "vue-router";
import constants from "../common/constants";
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/layout"),
    children: [
      {
        path: "",
        component: () => import("@/views/home"),
        name: "home",
      },
      {
        path: "service",
        component: () => import("@/views/service"),
        name: "service",
      },
      {
        path: "agency",
        component: () => import("@/views/agency/index.vue"),
        name: "agency"
      },
      {
        path: "user",
        component: () => import("@/views/user/index.vue"),
        name: "user",
      },
      {
        path: "foodAid",
        component: () => import("@/views/agency/components/foodAid/index.vue"),
        name: "foodAidap",
      },
      {
        path: "thirdList",
        component: () => import("@/views/thirdList/index.vue"),
        name: "thirdList"
      }
    ]
  },
  {
    path: "/login",
    component: () => import("@/views/login/index.vue"),
    name: "login",
  },
  {
    path: "/policeInfo",
    component: () => import("@/views/policeInfo/index.vue"),
    name: "policeInfo",
  },
  {
    path: "/policeDetail",
    component: () => import("@/views/policyDetails/index.vue"),
    name: "policeDetail"
  },
  {
    path: "/applicationRecord",
    component: () => import("@/views/applicationRecord/index.vue"),
    name: "applicationRecord"
  },
  {
    path: "/careConsultant",
    component: () => import("@/views/careConsultant/index.vue"),
    name: "careConsultant",
  },
  {
    path: "/queryResult",
    component: () => import("@/views/queryResult/index.vue"),
    name: "queryResult"
  },
  {
    path: "/serviceDetail",
    component: () => import("@/views/serviceDetail/index.vue"),
    name: "serviceDetail"
  },
  {
    path: "/applyOnline",
    component: () => import("@/views/applyOnline/index.vue"),
    name: "applyOnline"
  },
  {
    path: "/applyService",
    component: () => import("@/views/applyService/index.vue"),
    name: "applyService",
  },
  {
    path: "/personInfo",
    component: () => import("@/views/personInfo/index.vue"),
    name: "personInfo"
  },
  {
    path: "/familyApply",
    component: () => import("@/views/familyApply/index.vue"),
    name: "familyApply"
  },
  {
    path: "/addFamily",
    component: () => import("@/views/addFamily/index.vue"),
    name: "addFamily"
  },
  {
    path: "/myFamily",
    component: () => import("@/views/myFamily/index.vue"),
    name: "myFamily"
  },
  {
    path: "/agencyList",
    component: () => import("@/views/agencyList/index.vue"),
    name: "agencyList"
  },
  {
    path: "/agencyDetail",
    component: () => import("@/views/agencyDetail/index.vue"),
    name: "agencyDetail",
    beforeEnter: (to, from, next) => {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // XXX: 修复iOS版微信HTML5 History兼容性问题
      if (isiOS && to.path !== location.pathname) {
        // 此处不可使用location.replace
        location.assign(to.fullPath);
      } else {
        next();
      }
    }
  },
  {
    path: "/enjoyedService",
    component: () => import("@/views/enjoyedService/index.vue"),
    name: "enjoyedService"
  },
  {
    path: "/recordDetail",
    component: () => import("@/views/recordDetail/index.vue"),
    name: "recordDetail"
  },
  {
    path: "/familyInfo",
    component: () => import("@/views/familyInfo/index.vue"),
    name: "familyInfo"
  },
  {
    path: "/thirdDetail",
    component: () => import("@/views/thirdDetail/index.vue"),
    name: "thirdDetail"
  },
  {
    path: "/agreement",
    component: () => import("@/views/agreement/index.vue"),
    name: "agreement"
  },
  {
    path: "/privacy",
    component: () => import("@/views/privacy/index.vue"),
    name: "privacy"
  },
  // 每周菜单
  {
    path: "/weeklyMenu",
    component: () => import("@/views/weeklyMenu/index.vue"),
    name: "weeklyMenu",
    beforeEnter: (to, from, next) => {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // XXX: 修复iOS版微信HTML5 History兼容性问题
      if (isiOS && to.path !== location.pathname) {
        // 此处不可使用location.replace
        location.assign(to.fullPath);
      } else {
        next();
      }
    }
  },
  // 往期菜单
  {
    path: "/pastMenu",
    component: () => import("@/views/pastMenu/index.vue"),
    name: "pastMenu"
  },
  // 老年活动
  {
    path: "/oldAgeActivity",
    component: () => import("@/views/oldAgeActivity/index.vue"),
    name: "oldAgeActivity"
  },
   // 老年详情
   {
    path: "/oldAgeActivityDetail",
    component: () => import("@/views/oldAgeActivityDetail/index.vue"),
    name: "oldAgeActivityDetail"
  },

  // dadadadadadadadasdada
  // {
  //   path: "/organlist",
  //   name: "organList",
  //   component: () => import("@/views/organList/index"),
  //   beforeEnter: (to, from, next) => {
  //     var u = navigator.userAgent;
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     // XXX: 修复iOS版微信HTML5 History兼容性问题
  //     if (isiOS && to.path !== location.pathname) {
  //       // 此处不可使用location.replace
  //       location.assign(to.fullPath);
  //     } else {
  //       next();
  //     }
  //   },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/yljglist",
  //   name: "yljgList",
  //   component: () => import("@/views/organList/yljgList"),
  //   beforeEnter: (to, from, next) => {
  //     var u = navigator.userAgent;
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     // XXX: 修复iOS版微信HTML5 History兼容性问题
  //     if (isiOS && to.path !== location.pathname) {
  //       // 此处不可使用location.replace
  //       location.assign(to.fullPath);
  //     } else {
  //       next();
  //     }
  //   },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/zcdlist",
  //   name: "zcdList",
  //   component: () => import("@/views/organList/yljgList"),
  //   beforeEnter: (to, from, next) => {
  //     var u = navigator.userAgent;
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     // XXX: 修复iOS版微信HTML5 History兼容性问题
  //     if (isiOS && to.path !== location.pathname) {
  //       // 此处不可使用location.replace
  //       location.assign(to.fullPath);
  //     } else {
  //       next();
  //     }
  //   },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/ggsslist",
  //   name: "ggssList",
  //   component: () => import("@/views/organList/ggssList"),
  //   beforeEnter: (to, from, next) => {
  //     var u = navigator.userAgent;
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     // XXX: 修复iOS版微信HTML5 History兼容性问题
  //     if (isiOS && to.path !== location.pathname) {
  //       // 此处不可使用location.replace
  //       location.assign(to.fullPath);
  //     } else {
  //       next();
  //     }
  //   },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/fjzllist",
  //   name: "fjzlList",
  //   component: () => import("@/views/organList/fjzlList"),
  //   beforeEnter: (to, from, next) => {
  //     var u = navigator.userAgent;
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     // XXX: 修复iOS版微信HTML5 History兼容性问题
  //     if (isiOS && to.path !== location.pathname) {
  //       // 此处不可使用location.replace
  //       location.assign(to.fullPath);
  //     } else {
  //       next();
  //     }
  //   },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/organdetail",
  //   name: "organDetail",
  //   component: () => import("@/views/organList/detail"),
  //   beforeEnter: (to, from, next) => {
  //     var u = navigator.userAgent;
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     // XXX: 修复iOS版微信HTML5 History兼容性问题
  //     if (isiOS && to.path !== location.pathname) {
  //       // 此处不可使用location.replace
  //       location.assign(to.fullPath);
  //     } else {
  //       next();
  //     }
  //   },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/serviceItem",
  //   name: "serviceItem",
  //   component: () => import("@/views/organList/serviceItem"),
  //   // beforeEnter: (to, from, next) => {
  //   //   var u = navigator.userAgent;
  //   //   var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //   //   // XXX: 修复iOS版微信HTML5 History兼容性问题
  //   //   if (isiOS && to.path !== location.pathname) {
  //   //     // 此处不可使用location.replace
  //   //     location.assign(to.fullPath);
  //   //   } else {
  //   //     next();
  //   //   }
  //   // },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/serviceItem/detail/:index",
  //   name: "serviceDetail",
  //   component: () => import("@/views/organList/serviceDetail.vue"),
  //   // beforeEnter: (to, from, next) => {
  //   //   var u = navigator.userAgent;
  //   //   var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //   //   // XXX: 修复iOS版微信HTML5 History兼容性问题
  //   //   if (isiOS && to.path !== location.pathname) {
  //   //     // 此处不可使用location.replace
  //   //     location.assign(to.fullPath);
  //   //   } else {
  //   //     next();
  //   //   }
  //   // },
  //   meta: {
  //     requireAuth: true
  //   }
  // },

  // {
  //   path: "/msconsultant",
  //   name: "msConsultant",
  //   component: () => import("@/views/msConsultant/index"),
  //   meta: {
  //     keepAlive: true //此组件不需要被缓存
  //   }
  // },
  {
    path: "/map",
    name: "map",
    component: () => import("@/views/map/index"),
    // beforeEnter: (to, from, next) => {
    //   var u = navigator.userAgent;
    //   var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //   // XXX: 修复iOS版微信HTML5 History兼容性问题
    //   if (isiOS && to.path !== location.pathname) {
    //     // 此处不可使用location.replace
    //     location.assign(to.fullPath);
    //   } else {
    //     next();
    //   }
    // }
  }
  // {
  //   path: "/mapTb",
  //   name: "mapTb",
  //   component: () => import("@/views/map/mapTb")
  // },
  // {
  //   path: "/mslist",
  //   name: "msList",
  //   component: () => import("@/views/msConsultant/msList"),
  //   beforeEnter: (to, from, next) => {
  //     var u = navigator.userAgent;
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     // XXX: 修复iOS版微信HTML5 History兼容性问题
  //     if (isiOS && to.path !== location.pathname) {
  //       // 此处不可使用location.replace
  //       location.assign(to.fullPath);
  //     } else {
  //       next();
  //     }
  //   },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/msdetail",
  //   name: "msDetail",
  //   component: () => import("@/views/msConsultant/detail")
  // },
  // {
  //   path: "/mesdetail",
  //   name: "MesDetail",
  //   component: () => import("@/views/mesIssue/detail")
  // },

  // {
  //   path: "/msfwdetail",
  //   name: "msFwDetail",
  //   component: () => import("@/views/msConsultant/detail")
  // },
  // {
  //   path: "/maplist",
  //   name: "mapList",
  //   component: () => import("@/views/map/mapList"),
  //   beforeEnter: (to, from, next) => {
  //     var u = navigator.userAgent;
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     // XXX: 修复iOS版微信HTML5 History兼容性问题
  //     if (isiOS && to.path !== location.pathname) {
  //       // 此处不可使用location.replace
  //       location.assign(to.fullPath);
  //     } else {
  //       next();
  //     }
  //   },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/estimate",
  //   name: "estimate",
  //   component: () => import("@/views/estimate/index")
  // },
  // {
  //   path: "/olderList",
  //   name: "olderServiceList",
  //   component: () => import("@/views/organList/olderServiceList")
  // },
  // {
  //   path: "/ruleList",
  //   name: "ruleList",
  //   component: () => import("@/views/organList/ruleList")
  // },
  // {
  //   path: "/contractus",
  //   name: "contractUs",
  //   component: () => import("@/views/contractUs/index")
  // },
  // {
  //   path: "/service",
  //   name: "service",
  //   component: () => import("@/views/organList/olderServiceList"),
  //   beforeEnter: (to, from, next) => {
  //     var u = navigator.userAgent;
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     // XXX: 修复iOS版微信HTML5 History兼容性问题
  //     if (isiOS && to.path !== location.pathname) {
  //       // 此处不可使用location.replace
  //       location.assign(to.fullPath);
  //     } else {
  //       next();
  //     }
  //   },
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: "/mestab",
  //   name: "mesIssue",
  //   component: () => import("@/views/mesIssue/index")
  // },
  // {
  //   path: "/oldermeslist",
  //   name: "olderMeslist",
  //   component: () => import("@/views/mesIssue/olderList")
  // },
  // {
  //   path: "/olderdetail",
  //   name: "olderDetail",
  //   component: () => import("@/views/mesIssue/olderDetail")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach(route => {
  // window.document.title = constants[to.name]
  if (route.name === 'agencyList') {
    document.title = route.query.title;
    // console.log(route)
    // // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
    // if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    //   const hackIframe = document.createElement('iframe');
    //   hackIframe.style.display = 'none';
    //   hackIframe.src = '/static/html/fixIosTitle.html?r=' + Math.random();
    //   document.body.appendChild(hackIframe);
    //   setTimeout(_ => {
    //     document.body.removeChild(hackIframe)
    //   }, 300)
    // }
  } else {
    document.title = constants[route.name]
  }

  // 百度统计
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function() {
      // 每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove()
      var hm = document.createElement('script')
      hm.src = "https://hm.baidu.com/hm.js?554572c9009a4f7a5adda6589ecee434"
      hm.id = 'baidu_tj'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }, 100)

});



export default router;
